export enum DeviceTaskExecutionResult {
    ControllerResponseTimeout = -4,
    DeviceNotFound = -3,
    DeviceResponseTimeout = -2,
    Failed = -1,
    Unknown = 0,
    Executed = 1,
}